import { render, staticRenderFns } from "./allocationSituation.vue?vue&type=template&id=5ede3116&scoped=true&"
import script from "./allocationSituation.vue?vue&type=script&lang=js&"
export * from "./allocationSituation.vue?vue&type=script&lang=js&"
import style0 from "./allocationSituation.vue?vue&type=style&index=0&id=5ede3116&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ede3116",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/01-qym-hop-newmall-frontend-k8s@3/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ede3116')) {
      api.createRecord('5ede3116', component.options)
    } else {
      api.reload('5ede3116', component.options)
    }
    module.hot.accept("./allocationSituation.vue?vue&type=template&id=5ede3116&scoped=true&", function () {
      api.rerender('5ede3116', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/code/batchAddFriends/allocationSituation.vue"
export default component.exports